import { c as _c } from "react/compiler-runtime";
import { IcoArrowTopRight16 } from '@onefootprint/icons';
import type { AuditEventPlaybook } from '@onefootprint/request-types/dashboard';
import { LinkButton } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
type PlaybookLinkProps = {
  playbook: AuditEventPlaybook;
};
const PlaybookLinkButton = t0 => {
  const $ = _c(9);
  const {
    playbook
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "events.playbooks"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("security-logs", t1);
  const {
    playbookId,
    obConfigurationId
  } = playbook;
  let t2;
  if ($[1] !== obConfigurationId || $[2] !== playbookId) {
    t2 = () => `/playbooks/${playbookId}?version=${obConfigurationId}`;
    $[1] = obConfigurationId;
    $[2] = playbookId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getHref = t2;
  const href = getHref();
  let t3;
  if ($[4] !== t) {
    t3 = t(_temp);
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== href || $[7] !== t3) {
    t4 = <LinkButton href={href} iconComponent={IcoArrowTopRight16} target="_blank">{t3}</LinkButton>;
    $[6] = href;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default PlaybookLinkButton;
function _temp($) {
  return $.playbook;
}